import i18n from "../../i18n/i18n"

export enum ErrorCaseType {
    NotSet = 0,
    DoublePayment = 1,
    PaymentNotMatched = 2,
    PaymentGeneral = 3,
    PaymentBankPayment = 4,
    CardProduction = 5,
    Journalizing = 6,
    PaymentOnline = 7,
    PaymentByOtherMeans = 8,
    PaymentFreeOfCharge = 9
}

// tslint:disable-next-line:no-namespace
export namespace ErrorCaseType {
	export function displayName(type: ErrorCaseType) {
		const values: { [index: number]: string } = {
			1: "ENUM_ERRORCASETYPE_DOUBLEPAYMENT",
			2: "ENUM_ERRORCASETYPE_PAYMENTNOTMATCHED",
			3: "ENUM_ERRORCASETYPE_PAYMENTGENERAL",
			4: "ENUM_ERRORCASETYPE_PAYMENTBANKPAYMENT",
			5: "ENUM_ERRORCASETYPE_CARDPRODUCTION",
			6: "ENUM_ERRORCASETYPE_JOURNALIZING",
			7: "ENUM_ERRORCASETYPE_PAYMENTONLINE",
			8: "ENUM_ERRORCASETYPE_PAYMENTBYOTHERMEANS",
			9: "ENUM_ERRORCASETYPE_PAYMENTFREEOFCHARGE"
		}

		if (values.hasOwnProperty(type)) {
			return i18n.t(values[type])
		} else {
			return i18n.t(ErrorCaseType[type])
		}
	}
}
